module.exports = __webpack_public_path__ + "img/sticker_12.5edfed84.svg";